module.exports = __webpack_public_path__ + "img/emoji_14.f5cb2687.png";